import styled from 'styled-components';

const DropdownWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;
const GWFCard = styled.div`
  border: 1px solid #21aae8;
  border-radius: 7px;
  display: flex;
  padding: 32px 16px;
  margin-bottom: 16px;
  .content {
    margin-left: 32px;
    align-items: center;
  }
`;
const Input = styled.input`
  padding: 1em;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border: 1px solid rgba(25, 86, 138, 1);
  font-size: 16px;
  width: 200px;
`;
const Button = styled.button`
  background: rgba(25, 86, 138, 1);
  border: 1px solid rgba(25, 86, 138, 1);
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  position: absolute;
  top: 0;
  max-width: 200px;
  font-size: 16px;

  color: white;
  padding: 11.5px 20px;
  cursor: pointer;

  transition: all 200ms ease-in-out;
  &:hover {
    background: #468caa;
  }
`;

export default { DropdownWrap, GWFCard, Input, Button };
